export default {
	data() {
		return {
			hover: false
		};
	},
	methods: {
		hover_on() {
			this.hover = true;
		},
		hover_off() {
			this.hover = false;
		}
	}
};